<template lang="pug">
v-container(grid-list-md)
    v-layout(wrap class="menu")
        v-flex(lg12 md12 xs12 v-if="listDataAccount && listDataAccount.length > 0")
            v-data-table(
                hide-default-footer
                :headers="headers" 
                :loading="loading"
                loading-text="Proses mengambil data ....."
                no-data-text="Data tidak ditemukan ....."
                no-results-text="Data tidak ditemukan ....."
                :items="listDataAccount"
                :page.sync="page"
                :items-per-page="itemsPerPage"
                @page-count="pageCount = $event"
                :search="criteria"
            )
                
                template(v-slot:top)
                    v-container(grid-list-md)
                        v-layout(wrap menu-btn)
                            v-spacer
                            v-flex(lg5 md5 xs12)
                                v-text-field(dense v-model="criteria" label="Filter Data Pencarian" prepend-icon="mdi-magnify" clearable)
                template(v-slot:item.action="{item}")
                    v-layout(wrap justify-center menu-btn-sm my-1)
                        v-btn(color="info" @click="doAdd(item)" class="ma-1" v-if="!item.exist") Tambahkan
            div(class="text-xs-center ma-2")
                v-pagination(v-model="page" :length="pageCount")
        v-flex(lg12 md12 xs12 v-else)
            v-layout(row justify-center text-center class="font-weight-bold yellow lighten-4" )
                v-icon(class="ma-1" color="warning" large) mdi-alert
                div
                    div Corporate anda belum memiliki akses rekening
                    div Silahkan hubungi Customer Service untuk menambahkan akses rekening
        div(class="ma-2 menu-btn")
            v-btn(class="mx-1" @click="doCancel") Kembali
                v-icon mdi-arrow-left
</template>
<script>
export default {
    name: 'FAccountCorporateTable',
    props: ["corporateId", "listAccountGroup"],
    data() {
        return {
            listData: [],
            listGroup: [],
            loading: false,
            criteria: "",
            headers: [
                {text: 'NO. REKENING', value: 'accountNumber', sortable: false, width: "30%", class: "primary--text"},
                {text: 'ATAS NAMA', value: 'accountName', sortable: false, width: "40%", class: "primary--text"},
                {text: 'JENIS', value: 'accountTypeName', sortable: false, width: "20%", class: "primary--text"},
                {text: '', value: 'action', sortable: false, width: "120px", align:"center", class: "success--text"},
            ],
            page: 1,
            itemsPerPage: 5,
            pageCount: 0,
        }
    },
    watch: {
        listAccountGroup(val){
            this.listGroup = val ? val : [];
        },
        corporateId(val){
            this.doLoad();
        }
    },
    computed: {
        listDataAccount(){
            return this.listData.map(element => {
                if (this.existInGroup(element.accountNumber)) {
                    element.exist = true;
                }else{
                    element.exist = false;
                }
                return element;
            }).sort((a,b) => a.exist - b.exist);
        }
    },
    mounted() {
        this.doLoad();
    },
    methods: {
        doLoad(){
            if (this.corporateId) {
                this.loading = true;
                this.$http.get("/api/corporate/account/" + this.corporateId)
                .then(
                    success => {
                        this.listData = success.data;
                    },err => {
                        this.$message.error(err.response.data.message);
                    }).finally(() => (this.loading = false));
            }
           
        },
        existInGroup(accountNumber){
            let result = null;
            this.listGroup.map(element => {
                if (accountNumber === element.accountNumber) {
                    result = element;
                }
            });
            return result;
        },
        doAdd(item){
            this.$emit("add", item);
        },
        doCancel(){
            this.$emit("cancel");
        }
    },
}
</script>